module.exports = __webpack_public_path__ + "static/media/um.33756387.jpeg";